const rates = Object.freeze({
    // free: 1,
    standard: 1,
    enterprise: 2
})

const table = 'rates'

async function getCurrentRate(userId) {
    let t = 'rates_user'

    let q = await db.selectOne(t, {
        filter: { user_id: userId }
    })

    return q
}

async function getRates(userId = false, canEnterprise = false) {
    let q = await db.query(`SELECT * FROM ${table}`)

    if(userId) {
        let currentRate = await getCurrentRate(userId)

        for(let i in q) {
            q[i].active = currentRate && currentRate.rate_id == q[i].id
            q[i].disabled = q[i].name === 'ENTERPRISE' && !canEnterprise
            // min top up balance amount
            q[i].min_balance_topup_amount = q[i].name === 'ENTERPRISE' ? 25000 : 1500
        }
    }

    return q
}

async function getUserRate(userId) {
    let tRates = 'rates',
        tRatesUser = 'rates_user'

    let sql = `SELECT r.id, r.name, r.price, r.desc, r.subscription, r.claim_cost, r.paid_delivery
        FROM ${tRates} r
        JOIN ${tRatesUser} ru ON ru.rate_id = r.id
        WHERE ru.user_id = ${userId} LIMIT 1`

    let q = await db.query(sql)

    return q[0]
}

async function checkCompanyAcceptPayment(bin) {
    let t = 'companies_enterprise'

    let q = await db.selectOne(t, {
        filter: {
            bin: bin
        }
    })

    return q ? !!q.allow : false
}

async function getCurrentPlanMinBalanceTopupAmount(user_id) {
    let rates = await getRates(user_id)

    for(let i in rates) {
        if(rates[i].active) return rates[i].min_balance_topup_amount
    }

    return 0
}

module.exports = {
    rates,
    checkCompanyAcceptPayment,
    getCurrentPlanMinBalanceTopupAmount,
    getUserRate
}